<template>
	<div
		v-if="image || title || text"
		:id="$vnode.key"
		class="c-block-list-text-media-custom"
	>
		<LongReadTarget
			v-if="title && includeInToc"
			:container-id="$vnode.key"
			:title="title"
		/>

		<div
			class="
				flex flex-col
				>=605:flex-row
				gap-x-layout-gutter gap-y-xl
				items-center
			"
		>
			<div
				class="w-full >=605:w-2/5col >=1024:w-4/12col"
				:class="{
					'>=1024:pr-layout-gutter': mediaAlignment === 'left',
					'>=1024:pl-layout-gutter >=605:order-1':
						mediaAlignment === 'right',
				}"
			>
				<UmbracoImageExt
					v-if="image"
					:widths="[343, 384, 480, 550]"
					:alt="image.altText"
					:source-url="image.cropUrl"
					:source-width="image.width"
					:source-height="image.height"
					:aspect-ratio="mediaAlignment === 'left' ? 1 : 384 / 460"
					:class="[
						'w-full overflow-hidden',
						{ 'rounded-full': mediaAlignment === 'right' },
					]"
					:image-class-names="[
						'overflow-hidden',
						{ 'rounded-full': mediaAlignment === 'right' },
					]"
				/>
				<FallbackImage
					v-else
					:aspect-ratio="mediaAlignment === 'left' ? 1 : 384 / 460"
					:class="[
						'w-full overflow-hidden',
						{ 'rounded-full': mediaAlignment === 'right' },
					]"
				/>
			</div>
			<div class="w-full >=605:w-3/5col >=1024:w-4/12col">
				<BaseH2 v-if="title" v-text="title"></BaseH2>
				<div
					v-if="text"
					class="s-rich-text"
					:class="{ 'mt-lg': title }"
					v-html="text"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
import LongReadTarget from '~/citi-baseline/components/LongRead/LongReadTarget';
import UmbracoImageExt from '~/components/shared/UmbracoImageExt';
import FallbackImage from '~/components/shared/FallbackImage';

export default {
	name: 'BlockListTextMediaCustom',
	components: { LongReadTarget, UmbracoImageExt, FallbackImage },
	inheritAttrs: false,

	props: {
		text: String,
		includeInToc: Boolean,
		image: Object,
		title: String,
		mediaAlignment: String,
	},
};
</script>
